import styled from "styled-components";
import { dispositivo } from "../../../../components/Dispositivos";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

export const TablaNota = styled.table`
  justify-content: center;
  margin-left: 5%;
  margin-bottom: 3%;
  @media ${dispositivo.tablet} {
    margin-left: 3%;
    margin-bottom: 2%;
  }
  @media ${dispositivo.mobileL} {
    margin-left: 1%;
    margin-bottom: 1%;
  }
`;

export const LabelNota = styled.td`
  text-align: left;
`;

export const ButtonActionNota = styled(Button)`
  && {
    background-color: #0c8de3;
    border: none;
    color: white;
    text-align: center;
    font-size: 14px;
    margin: 2%;
    padding-bottom: 0.8%;
    border-radius: 4px;
    transition: 0.3s;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;
    @media ${dispositivo.tablet} {
      font-size: 12px;
    }
    @media ${dispositivo.mobileL} {
      font-size: 10px;
    }
  }
`;

export const ContainerNuevaNota = styled.div`
  justify-content: center;
`;

export const ContainerNuevaNotaTitulo = styled.div`
  text-align: center;
  color: #707070;
  background: #fff;
  padding: 1% !important;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 8rem;
  border-radius: 10px;
  background-color: #64bdff30;
  border: none;
  outline: none;
  color: #474747;
  padding-left: 12px;
  line-height: 2.5;
  font-size: 1rem;
  &::placeholder {
    color: #04000060;
    fonst-size: 0.5rem;
  }
  &:focus{
    border: 2px solid #0060b0;
  }
`;

///////////
export const MainContainer = styled.div`
  height: 100%;
  justify-content: center;
  text-align: center;
`;

export const ContainerTitle = styled.div`
  font-size: 12px;
  font-weight: normal;
  text-align: center;
`;

export const ContainerTitleText = styled.h2`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 15px;
  background-color: #0c8de3;
  color: white;
  border-radius: 10px;
`;

export const ButtonPagar = styled.button`
  height: 2.25rem;
  font-size: 0.9rem;  
  width: 7rem;
  border-radius: 0.8rem;      
  text-transform: uppercase;
  cursor: pointer;
  font-width: bold;
  background-color: #0060b0;
  color: #ffffff;
  border: none;
  &:hover{
    color:#000000;
    background-color: #0c8de390;
    font-width: bold;
  }
  @media ${dispositivo.tablet}{
    width: 10rem;
    font-size: 1rem;  
  }  
  @media ${dispositivo.laptop} {      
    width: 12.5rem;
  }
`;
export const LinkCancelar = styled.button`
  height: 2.25rem;
  font-size: 0.9rem;  
  width: 7rem;
  border-radius: 0.8rem;      
  text-transform: uppercase;
  cursor: pointer;
  font-width: bold;
  background-color: #ffffff;
  border: 2px solid #0060b0;
  color: #0060b0;
  margin-right: 1rem;
  &:hover {
    color:#000000;
    background-color: #0c8de390;
    font-width: bold;
    border: none;
  }
  @media ${dispositivo.tablet}{
    width: 10rem;
    font-size: 1rem;  
  }  
  @media ${dispositivo.laptop} {      
    width: 12.5rem;
  }
`;

export const BodyContainer = styled.div`
  display: flex;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  justify-content: center;
  text-align: center;
`;

export const StyledForm = styled.form`
  width: 90%;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const Tabla = styled.table`
  width: 100%;
  justify-content: center;
  text-align: center;
`;

export const TablaHeader = styled.thead`
  background: #0c8de3;
  padding-left: 1px;
  padding-right: 1px;
  padding-top: 16px;
  padding-bottom: 16px;
  justify-content: center;
  text-align: center;
`;

export const TablaHeaderTextoItems = styled.th`
  font-size: 12px;
  font-weight: normal;
  color: #040404;
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: center;
  text-align: left;
  width: 50%;
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 16px;
  }
`;
export const TablaHeaderTextoValues = styled.th`
  font-size: 12px;
  color: #045184;
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: center;
  text-align: right;
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 16px;
  }
`;
export const TablaHeaderTextoButtons = styled.th`
  font-size: 12px;
  font-weight: normal;
  color: #707070;
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: center;
  text-align: center;
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 18px;
  }
`;

export const TablaHeaderTextoNumber = styled.th`
  font-size: 12px;
  font-weight: normal;
  color: #707070;
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: right;
  text-align: right;
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 18px;
  }
`;

export const TablaHeaderTexto = styled.th`
  font-size: 12px;
  font-weight: normal;
  color: #707070;
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: right;
  text-align: right;
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 18px;
  }
`;

export const TablaBody = styled.tbody`
  padding-left: 1px;
  padding-right: 1px;
  padding-top: 16px;
  padding-bottom: 16px;
  vertical-align: middle;
`;

export const TablaBodyTexto = styled.th`
  font-size: 12px;
  font-weight: normal;
  color: #707070;
  padding-top: 8px;
  padding-bottom: 8px;
  vertical-align: middle;
  text-align: left;
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 18px;
  }
`;

export const SelectStyle = styled.select`
  width: 50%;
  vertical-align: middle;
`;

export const StyledInput = styled.input`
  width: 45%;
  color: #707070;
  vertical-align: middle;
  text-align: right;
  padding-left: 12px;
  padding-right: 0px;
  &:focus {
    outline: none;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 1rem;
  margin: 1em 0;
`;

export const ContainerBody = styled.div`
  width: 100%;
  height: 100%;
  padding: 2%;
  background: #fff;
  display: block;
  justify-content: center;
  border-radius: 10px;
  border: 2px solid #0c8de3;
  @media ${dispositivo.tablet} {
    display: block;
  }
  @media ${dispositivo.mobileL} {
    display: block;
  }
`;
